module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-container', {
    staticClass: "settings"
  }, [_c('v-slide-y-transition', {
    attrs: {
      "mode": "out-in"
    }
  }, [_c('v-layout', {
    attrs: {
      "align-center": "",
      "justify-center": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": "",
      "md6": ""
    }
  }, [_c('v-select', {
    attrs: {
      "label": _vm.$t('Theme Color'),
      "items": _vm.themeColorArrTrans
    },
    model: {
      value: (_vm.themeColor),
      callback: function($$v) {
        _vm.themeColor = $$v
      },
      expression: "themeColor"
    }
  }), _vm._v(" "), _c('v-select', {
    attrs: {
      "label": _vm.$t('Language'),
      "items": _vm.langArrTrans
    },
    model: {
      value: (_vm.lang),
      callback: function($$v) {
        _vm.lang = $$v
      },
      expression: "lang"
    }
  })], 1)], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-bea09ae6","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/pages/Settings.vue
// module id = 436
// module chunks = 1